<div style="width:100px">
    <content-loader [foregroundColor]="secondaryColor" viewBox="0 0 200 50">
      <svg:circle cx="30" cy="30" r="20" />
      <svg:rect prima x="80" y="25" rx="3" ry="3" width="200" height="20" />
    </content-loader>
  </div>
